interface Grecaptcha {
  execute(siteKey: string, options: { action: string }): Promise<string>
  ready(callback: () => void): void
  [key: string]: any
}

export const useRecaptcha = (
  siteKey: string | null,
  actionType: string = 'submit'
): Promise<string | null> => {
  return new Promise((resolve) => {
    const grecaptcha: Grecaptcha = (window as any).grecaptcha

    if (!grecaptcha || !siteKey) {
      resolve(null)
    } else {
      grecaptcha.ready(async () => {
        try {
          const token = await grecaptcha.execute(siteKey, {
            action: actionType,
          })
          resolve(token)
        } catch (error) {
          resolve(null)
        }
      })
    }
  })
}
